import {Injectable} from '@angular/core';


declare var $: any;

@Injectable()
export class NotificationService {
  
  private colorWarning = "#C79121";
  private colorSuccess = "grey";
  private colorError = "#C46A69";
  private timeDefault = 5000;

  constructor() {

  }

  smallBox(data, cb?) {
    $.smallBox(data, cb)
  }

  smallBoxOK(title: string, content:string, cb?) {
    this.smallBox({
          title: title,
          content: content,
          color: this.colorSuccess,
          iconSmall: "fa fa-check",
          timeout: this.timeDefault
        });
  }

  smallBoxWarning(title: string, content:string, cb?) {
    this.smallBox({
          title: title,
          content: content,
          color: this.colorWarning,
          iconSmall: "fa fa-warning",
          timeout: this.timeDefault
        });
  }

  smallBoxError(title: string, content:string, cb?) {
    this.smallBox({
          title: title,
          content: content,
          color: this.colorError,
          iconSmall: "fa fa-error",
          timeout: this.timeDefault
        });
  }

  bigBox(data, cb?) {
    $.bigBox(data, cb)
  }

  smartMessageBox(data, cb?) {
    $.SmartMessageBox(data, cb)
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/utils/notification.service.ts